module.exports = __webpack_public_path__ + "img/triangle-65.fe0f0cc6.gif";